export default __webpack_public_path__ + "static/media/review-person-1.514fd450.png";